export default __webpack_public_path__ + "static/13_16-0dac8115978787f5d3a41533321e8798.png";